<template>
  <div class="molded-seat-step-nine">
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex sm4>
        <v-textarea
          v-model="form.fitting_comment"
          filled
          style="height:100%"
          name="Commentaire essayage :"
          label="Commentaire essayage :"
        />
      </v-flex>
      <v-flex
        column
        sm8
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_selle_positionnement_1a.svg">
            <v-text-field
              v-model="form.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_a') }"
              data-vv-name="schema_3_a"
              outlined
              type="number"
              style="top: 61.6%;left: 0.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_b') }"
              data-vv-name="schema_3_b"
              outlined
              type="number"
              style="top: 48.6%;left: 8.8%;"
              height="100%"
            />
            <v-text-field
              v-model="form.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_c') }"
              data-vv-name="schema_3_c"
              outlined
              type="number"
              style="top: 28.1%;left: 32.9%;"
              height="100%"
            />
            <v-text-field
              v-model="form.d"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_d') }"
              data-vv-name="schema_3_d"
              outlined
              type="number"
              style="top: 45.6%;left: 35.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.e"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_e') }"
              data-vv-name="schema_3_e"
              outlined
              type="number"
              style="top: 59.3%;left: 38.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.f"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_f') }"
              data-vv-name="schema_3_f"
              outlined
              type="number"
              style="top: 57.3%;left: 56.9%;"
              height="100%"
            />
            <v-text-field
              v-model="form.g"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_g') }"
              data-vv-name="schema_3_g"
              outlined
              type="number"
              style="top: 45.5%;left: 66.5%;"
              height="100%"
            />
            <v-text-field
              v-model="form.h"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_h') }"
              data-vv-name="schema_3_h"
              outlined
              type="number"
              style="top: 75.4%;left: 62.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.i"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_i') }"
              data-vv-name="schema_3_i"
              outlined
              type="number"
              style="top: 33.3%;left: 77.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.j"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_j') }"
              data-vv-name="schema_3_j"
              outlined
              type="number"
              style="top: 16.5%;left: 90.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.k"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_k') }"
              data-vv-name="schema_3_k"
              outlined
              type="number"
              style="top: 89.8%;left: 12.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.l"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_l') }"
              data-vv-name="schema_3_l"
              outlined
              type="number"
              style="top: 89.8%;left: 25.6%;"
              height="100%"
            />
            <v-text-field
              v-model="form.m"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_m') }"
              data-vv-name="schema_3_m"
              outlined
              type="number"
              style="top: 89.8%;left: 38.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.n"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('schema_3_n') }"
              data-vv-name="schema_3_n"
              outlined
              type="number"
              style="top: 89.8%;left: 51.3%; width: 45.7%"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mt-8
      wrap
    >
      <v-flex
        v-for="article in articlesList"
        :key="article.article_id"
        sm6
      >
        <v-layout class="checkbox-input-container">
          <v-flex>
            <v-checkbox
              v-model="getArticleFormData(article.article_id).idc_want"
              :label="article.label"
              hide-details
              @change="onArticleCheckChange(article.article_id, $event)"
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex
            v-if="article.idc_entry"
            class="checkbox-input visible"
          >
            <InputNumber
              v-model="getArticleFormData(article.article_id).value"
              class="input-number"
              :disable="!getArticleFormData(article.article_id).idc_want"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "MoldedSeatStepNine",
  inject: ["parentValidator"],
  components: {
    InputNumber
  },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Récupère les données d'un article dans form.articles à partir de son ID
     * @param {String|Number} articleId - L'ID de l'article à récupérer
     * @returns {Object} - L'objet article correspondant dans form.articles
     */
    getArticleFormData(articleId) {
      // Chercher l'article dans form.articles
      const article = this.form.articles.find(a => a.article_id === articleId);
      
      // Si l'article n'existe pas, créer un nouvel objet avec des valeurs par défaut
      if (!article) {
        const newArticle = {
          article_id: articleId,
          idc_want: false,
          value: null
        };
        
        this.form.articles.push(newArticle);
        
        return newArticle;
      }
      
      return article;
    },
    
    /**
     * Réinitialise la valeur d'un article à null lorsqu'il est décoché
     * @param {String|Number} articleId - L'ID de l'article
     * @param {Boolean} checked - État de la case à cocher
     */
    onArticleCheckChange(articleId, checked) {
      const article = this.getArticleFormData(articleId);
      if (!checked && article.value !== null) {
        article.value = null;
      }
    }
  },
  async created() {
    this.$validator = this.parentValidator;
    await this.loadArticles("MOLDED_SEAT");

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-nine {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 10.1%;
        height: 8.6%;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .v-textarea {
    height: 100%;
    .v-input__control {
      height: 100%;
      .v-input__slot {
        height: 100%;
      }
    }
  }
}
</style>
